import createIcon from '../../createIcon';

/**
 * @component @name DragIndicator
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTEgMThDMTEgMTkuMSAxMC4xIDIwIDkgMjBDNy45IDIwIDcgMTkuMSA3IDE4QzcgMTYuOSA3LjkgMTYgOSAxNkMxMC4xIDE2IDExIDE2LjkgMTEgMThaTTkgMTBDNy45IDEwIDcgMTAuOSA3IDEyQzcgMTMuMSA3LjkgMTQgOSAxNEMxMC4xIDE0IDExIDEzLjEgMTEgMTJDMTEgMTAuOSAxMC4xIDEwIDkgMTBaTTkgNEM3LjkgNCA3IDQuOSA3IDZDNyA3LjEgNy45IDggOSA4QzEwLjEgOCAxMSA3LjEgMTEgNkMxMSA0LjkgMTAuMSA0IDkgNFpNMTUgOEMxNi4xIDggMTcgNy4xIDE3IDZDMTcgNC45IDE2LjEgNCAxNSA0QzEzLjkgNCAxMyA0LjkgMTMgNkMxMyA3LjEgMTMuOSA4IDE1IDhaTTE1IDEwQzEzLjkgMTAgMTMgMTAuOSAxMyAxMkMxMyAxMy4xIDEzLjkgMTQgMTUgMTRDMTYuMSAxNCAxNyAxMy4xIDE3IDEyQzE3IDEwLjkgMTYuMSAxMCAxNSAxMFpNMTUgMTZDMTMuOSAxNiAxMyAxNi45IDEzIDE4QzEzIDE5LjEgMTMuOSAyMCAxNSAyMEMxNi4xIDIwIDE3IDE5LjEgMTcgMThDMTcgMTYuOSAxNi4xIDE2IDE1IDE2WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const DragIndicator = createIcon('DragIndicator', [
  [
    'path',
    {
      d: 'M11 18C11 19.1 10.1 20 9 20C7.9 20 7 19.1 7 18C7 16.9 7.9 16 9 16C10.1 16 11 16.9 11 18ZM9 10C7.9 10 7 10.9 7 12C7 13.1 7.9 14 9 14C10.1 14 11 13.1 11 12C11 10.9 10.1 10 9 10ZM9 4C7.9 4 7 4.9 7 6C7 7.1 7.9 8 9 8C10.1 8 11 7.1 11 6C11 4.9 10.1 4 9 4ZM15 8C16.1 8 17 7.1 17 6C17 4.9 16.1 4 15 4C13.9 4 13 4.9 13 6C13 7.1 13.9 8 15 8ZM15 10C13.9 10 13 10.9 13 12C13 13.1 13.9 14 15 14C16.1 14 17 13.1 17 12C17 10.9 16.1 10 15 10ZM15 16C13.9 16 13 16.9 13 18C13 19.1 13.9 20 15 20C16.1 20 17 19.1 17 18C17 16.9 16.1 16 15 16Z',
      key: 'l6hb9t',
    },
  ],
]);

export default DragIndicator;
